import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { useOffert } from "@/components/OffertModal";
import { trackContact } from "@/lib/metaPixel";

/**
 * Floating CTA button for desktop that appears after scrolling past
 * the first viewport height. Complements the mobile sticky bar.
 * Only visible on lg+ screens.
 */
export default function FloatingDesktopCta() {
  const { openOffert } = useOffert();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~1 viewport height
      setVisible(window.scrollY > window.innerHeight);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="hidden lg:flex fixed bottom-8 left-1/2 -translate-x-1/2 z-40 items-center gap-3 bg-white/95 backdrop-blur-md shadow-xl rounded-full px-2 py-2 border border-border/50 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <button
        onClick={() => openOffert("floating-desktop-cta")}
        className="bg-rose hover:bg-rose-dark text-white font-medium px-6 py-2.5 rounded-full text-sm transition-colors"
      >
        Kostnadsfri offert
      </button>
      <a
        href="tel:+46841026111"
        onClick={() => trackContact({ content_name: "Floating Desktop CTA", method: "phone" })}
        className="flex items-center gap-1.5 text-navy font-medium text-sm px-4 py-2.5 rounded-full hover:bg-sand transition-colors"
      >
        <Phone className="w-4 h-4" />
        08-410 26 111
      </a>
    </div>
  );
}
